import $ from 'jquery';
import whenDomReady from 'when-dom-ready';
import ViewAccountAddresses from 'Views/view-account-addresses';
import ViewAccountOrder from 'Views/view-account-order';

'use strict'

whenDomReady(function(){
  console.log('init account');

  // normalize navi tab widths

  var tabs = $('.navi>div');
  var tabWidths = tabs.map(function () { return $(this).width(); }).get();
  var maxTabWidth = Math.ceil(Math.max.apply(null, tabWidths)) + 1;

  tabs.each(function () {
    var $tab = $(this);
    $tab.width(maxTabWidth);
    $(this).css({ paddingLeft: 0, paddingRight: 0 });
  });

  // fix orders list width (mobile) and address block widths

  var naviWidth = 'calc(' + (maxTabWidth * tabWidths.length) + 'px + ' + (11 * tabWidths.length) + 'rem)';
  $('.orders-list').width(naviWidth)
  $('.addresses-wrapper').width(naviWidth);

  // create views

  $('#addresses-container').length && new ViewAccountAddresses({ el: $('#addresses-container') });
  $('#order-container').length && new ViewAccountOrder({ el: $('#order-container') });

  // show DOM content

  $('.account-container').css('visibility', 'visible');
  $('.account-container').css('opacity', '1');
})